import { Component, OnInit } from '@angular/core';
import { ClientDetailInstance } from '../client-detail.instance';

@Component({
  selector: 'cw-client-detail-main',
  templateUrl: './client-detail-main.component.html',
  styleUrls: ['./client-detail-main.component.scss']
})
export class ClientDetailMainComponent implements OnInit {

  constructor(private instance: ClientDetailInstance) {
  }

  ngOnInit() {
  }

  get client() {
    return this.instance.client;
  }

}



// WEBPACK FOOTER //
// ./src/app/clients/client-detail/client-detail-main/client-detail-main.component.ts